import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';
import styled from 'styled-components';

/* RN: There actually isn't a Divider(Line) component in Primer, but some components like ActionList have such a divider as child component.
   This is often useful for separating content so added here.
*/

export const DividerLine = () => {
  return <StyledDivider />;
};

const StyledDivider = styled.div`
  height: 1px;
  background-color: ${themeGet('colors.border.default')};
  margin-top: ${themeGet('space.2')};
  margin-bottom: ${themeGet('space.2')};
`;
